import React, { useMemo } from "react";
import HelpCenterSlideNode from "@/v2-components/pages/support/components/help-center/header/help-center-slide-node";
import type { SupportCategory } from "@/v2-components/pages/support/types/support-data";

interface HelpCenterSlideTree {
  data: SupportCategory[];
  onCloseSlide: () => void;
  query?: string;
}

//specific "new" item ids select
const NEW_ITEM_IDS = [
  "device",
  "device-tactsuit-pro",
  "device-tactsuit-air",
  "device-tactsleeve",
];
/*
 slide tree
 */
export const HelpCenterSlideTree = ({
  data,
  onCloseSlide,
  query,
}: HelpCenterSlideTree) => {
  const filteredData = useMemo(() => addNewBadgeNode(data), [data]);
  if (!filteredData?.length) return null;

  return (
    <section className="flex overflow-x-hidden">
      <div className="w-full text-base">
        {filteredData.map((node) => (
          <HelpCenterSlideNode
            key={node.id}
            node={node}
            onCloseSlide={onCloseSlide}
            query={query}
          />
        ))}
      </div>
    </section>
  );
};

type WithIsNew = SupportCategory & { isNew?: boolean };

const addNewBadgeNode = (data: SupportCategory[]): WithIsNew[] => {
  return data?.map((item) => ({
    ...item,
    isNew: NEW_ITEM_IDS.includes(item.id),
    children: item.children ? addNewBadgeNode(item.children) : undefined,
  }));
};
